import React from 'react';
import Helpers from 'utils/helpers';
import './spinner.css';

export default function Spinner(props) {
  switch (props.animation) {
    case 'border': return <BorderSpinner {...props} />;
    case 'border-chase': return <BorderChaseSpinner {...props} />;
    case 'border-swap': return <BorderSwapSpinner {...props} />;
    case 'wave': return <WaveSpinner {...props} />;
    case 'dot-chase': return <DotChaseSpinner {...props} />;
    case 'dot-grow': return <DotGrowSpinner {...props} />;
    case 'circular': return <CircularSpinner {...props} />;
    default: return null;
  }
}

function BorderSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-border', props.className];
    if (props.variant) {
      classNames.push(`text-${props.variant}`);
    }
    if (props.size) {
      classNames.push(`spinner-border-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  return <div className={getClass()} style={props.style}></div>;
}

function BorderChaseSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-border-chase', props.className];
    if (props.variant) {
      classNames.push(`text-${props.variant}`);
    }
    if (props.size) {
      classNames.push(`spinner-border-chase-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <div className='spinner-border-chase-1'></div>
      <div className='spinner-border-chase-2'></div>
      <div className='spinner-border-chase-3'></div>
      <div className='spinner-border-chase-4'></div>
    </div>
  );
}

function BorderSwapSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-border-swap', props.className];
    if (props.variant) {
      classNames.push(`text-${props.variant}`);
    }
    if (props.size) {
      classNames.push(`spinner-border-swap-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <div className='spinner-border-swap-11'></div>
      <div className='spinner-border-swap-12'></div>
      <div className='spinner-border-swap-21'></div>
      <div className='spinner-border-swap-22'></div>
    </div>
  );
}

function WaveSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-wave', props.className];
    if (props.size) {
      classNames.push(`spinner-wave-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  const getItemClass = (index) => {
    let classNames = [`spinner-wave-${index}`];
    if (props.variant) {
      classNames.push(`bg-${props.variant}`);
    }
    else {
      classNames.push('bg-text');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <div className={getItemClass(1)}></div>
      <div className={getItemClass(2)}></div>
      <div className={getItemClass(3)}></div>
      <div className={getItemClass(4)}></div>
      <div className={getItemClass(5)}></div>
    </div>
  );
}

function DotChaseSpinner(props) {
  const getClass = () => {
    let classNames = ['spiner', 'spinner-dot-chase', props.className];
    if (props.size) {
      classNames.push(`spinner-dot-chase-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  const getItemClass = (index) => {
    let classNames = [`spinner-dot-chase-${index}`];
    if (props.variant) {
      classNames.push(`bg-${props.variant}`);
    }
    else {
      classNames.push('bg-text');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <div className={getItemClass(1)}></div>
      <div className={getItemClass(2)}></div>
    </div>
  );
}

function DotGrowSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-grow', props.className];
    if (props.variant) {
      classNames.push(`text-${props.variant}`);
    }
    if (props.size) {
      classNames.push(`spinner-grow-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  return <div className={getClass()} style={props.style}></div>;
}

function CircularSpinner(props) {
  const getClass = () => {
    let classNames = ['spinner', 'spinner-circular', props.className];
    if (props.variant) {
      if (props.variant === 'rotate') {
        classNames.push('spinner-circular-color-change');
      }
      else {
        classNames.push(`text-${props.variant}`);
      }
    }
    if (props.size) {
      classNames.push(`spinner-circular-${props.size}`);
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className={getClass()} style={props.style}>
      <svg viewBox='22 22 44 44'>
        <circle cx='44' cy='44' r='19.4' fill='none' strokeWidth='4.8'></circle>
      </svg>
    </div>
  );
}